<template>
  <div>
    <div class="inquiryButton">
      <img src="/static/img/unCollecplan.png"
           id="unCollecplan"
           @click="unCollecplan()"
           v-if="collectionStatus">
      <img src="/static/img/collecplan.png"
           id="collecplan"
           @click="collecplan()"
           v-else>
      <br />
      <img src="/static/img/zixun.png"
           id="inquiryButton"
           @click="inquiry()">
    </div>
    <!--面包蟹-->
    <div class="container"
         style="height: 40px; line-height: 40px; color: #999">
      <i class="iconfont icon-ziyuan"></i>&nbsp;
      <span class="font_link_fw">
        <router-link :to="{name: 'home'}">首页</router-link>
      </span> &nbsp;&nbsp;>&nbsp;&nbsp;
      <span v-if="$route.query.title"
            class="productHref"
            @click="listShow=!listShow">专业服务&nbsp;&nbsp;>&nbsp;&nbsp;</span>
      <span v-if="$route.query.title">
        <router-link :to="'/serviceList?title='+$route.query.title">
          {{$route.query.title}}</router-link>&nbsp;&nbsp;>&nbsp;&nbsp;
      </span>
      <span v-if="$route.query.title1">
        <router-link :to="'/serviceList?title='+$route.query.title+'&title1='+$route.query.title1">
          {{$route.query.title1}}</router-link>&nbsp;&nbsp;>&nbsp;&nbsp;
      </span>
      <span style="color: #666"><b>{{$route.query.key}}</b></span>
    </div>
    <!-- 导航 -->
    <div class="container">
      <div class="bread-crumb"
           style="position: relative; ">
        <div class="menu_list"
             v-show="listShow"
             @mouseout="moveOut"
             @mouseover="moveOver">
          <div style="background-color: #679dcc;">
            <li style="background-color:transparent; color: #fff"><b>serviceList</b></li>
          </div>
          <!-- <div v-for="(item, miIndex) in solutionMenuList" :key="miIndex">
            <li style="background-color:transparent;" @click="changeMenu(item.name)">{{item.name}}</li>
          </div> -->
          <div>
            <li style="background-color:transparent;"
                @click="changeMenu('检维修服务')">检维修服务</li>
            <li style="background-color:transparent;"
                @click="changeMenu('培训服务')">培训服务</li>
            <li style="background-color:transparent;"
                @click="changeMenu('咨询设计服务')">咨询设计服务</li>
            <li style="background-color:transparent;"
                @click="changeMenu('供应链代采服务')">供应链代采服务</li>
          </div>
        </div>
      </div>
    </div>
    <!--引入内容部分-->
    <div class="container content topMargin">
      <div style="width: 100%">
        <div class="divimg">
          <div v-for="(item, index) of imgList"
               :key="index">
            <img :src="item.url">
          </div>
        </div>
        <div style="width:100%;text-align:center">
          <!-- <el-button type="warning" size="medium" @click="inquiry()">咨询</el-button> -->
          <!-- <el-button type="warning" size="medium" @click="collectionHandle()">{{collectionOrNot}}</el-button> -->
          <!-- <el-button type="warning" size="medium" @click="ss()">ss</el-button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dataList from '@/data/solution_list_detail'
import { setStorage, getStorage } from '@/utils/storage'
import { getAccessToken } from '@/utils/userInfo'
export default {
  name: 'planContent',
  data () {
    return {
      imgSrc: '',
      dataSelf: dataList,
      collectionOrNot: '收藏',
      imgList: [],
      thumbnailUrl: '',
      solutionMenuList: [],
      timer: '',
      listShow: false,
      collectionStatus: false
    }
  },
  computed: {},
  methods: {
    // 咨询
    async inquiry () {
      if (getAccessToken()) {
        let _this = this
        let inquiryButton = document.getElementById('inquiryButton')
        inquiryButton.style.pointerEvents = 'none'
        inquiryButton.cursor = 'not-allowed'
        let params = {
          userId: '',
          solutionCollection: [{
            title: this.$route.query.title,
            title1: this.$route.query.title1 || '',
            key: this.$route.query.key,
            name: this.$route.query.title,
            url: encodeURIComponent(window.location.href),
            solutionId: this.$route.query.id
          }]
        }
        // http
        this.$request.get(`/sys/user/info`).then((data) => {
          if (!data.user.customerId) {
            this.$router.push({ name: 'userGuide' })
            return false
          }
          params.userId = data.user.userId
          _this.$request.post(`/consultation/consultationrecord/save`, params)
            .then(_data => {
              _this.$confirm('您已发起了该方案的咨询、请在我的咨询里查找。我们会及时与您联系！', '友情提示', {
                showCancelButton: false,
                confirmButtonText: '确定',
                type: 'success'
              })
              inquiryButton.style.pointerEvents = ''
              inquiryButton.cursor = ''
            })
            .catch(() => {
              inquiryButton.style.pointerEvents = ''
              inquiryButton.cursor = ''
            })
        })
      } else {
        this.$router.push({ name: 'login' })
      }
    },
    // 方案收藏
    async collecplan () {
      let _this = this
      let params = {
        key: this.$route.query.key,
        planUrl: encodeURIComponent(window.location.href),
        planName: this.$route.query.key,
        title: this.$route.query.title,
        title1: this.$route.query.title1 || '',
        createTime: this.format(),
        collectorId: '',
        solutionId: this.$route.query.id,
        thumbnailUrl: this.thumbnailUrl
      }
      // console.log(params)
      // 登录
      if (getAccessToken()) {
        let collecPlan = document.getElementById('collecplan')
        collecPlan.style.pointerEvents = 'none'
        collecPlan.cursor = 'not-allowed'
        // http 添加商品到收藏列表
        this.$request.get(`/sys/user/info`).then((data) => {
          if (!data.user.customerId) {
            this.$router.push({ name: 'userGuide' })
            return false
          }
          params.collectorId = data.user.id
          delete params.createTime
          delete params.thumbnailUrl
          _this.$request.post(`/plan/collectionplan/save`, [params])
            .then((_data) => {
              _this.$confirm('您已收藏了该方案、请在方案咨询里查找！', '友情提示', {
                showCancelButton: false,
                confirmButtonText: '确定',
                type: 'success'
              })
              collecPlan.style.pointerEvents = ''
              collecPlan.cursor = ''
              _this.getCollectionStatus()
            })
            .catch(() => { })
        })
      } else { // 未登录
        // sessionStorage.removeItem('v1solutionList')
        let solutionList = getStorage('solutionList')
        if (!solutionList) {
          solutionList = []
          setStorage('solutionList', solutionList)
        }
        solutionList.push(params)
        // 去重
        let result = []
        let obj = {}
        for (let i = 0; i < solutionList.length; i++) {
          // console.log(obj[solutionList[i].key])
          if (!obj[solutionList[i].solutionId]) {
            result.push(solutionList[i])
            obj[solutionList[i].solutionId] = true
          }
        }
        setStorage('solutionList', result)
        _this.$confirm('您已收藏了该方案、请在方案咨询里查找！', '友情提示', {
          showCancelButton: false,
          confirmButtonText: '确定',
          type: 'success'
        })
        // console.log(getStorage('solutionList'))
        _this.getCollectionStatus()
      }
    },
    // 取消收藏
    unCollecplan () {
      if (getAccessToken()) {
        this.$request.post(`/plan/collectionplan/cancelCollectionPlanBySolutionId`, { solutionId: this.$route.query.id })
          .then(_data => {
            this.$message({
              message: '取消收藏成功！',
              type: 'success'
            })
            this.getCollectionStatus()
          })
          .catch(() => {
          })
      } else {
        let solutionList = getStorage('solutionList')
        let ind = -1
        if (!solutionList) {
          solutionList = []
        }
        solutionList.forEach((item, index) => {
          if (item.solutionId.toString() === this.$route.query.id.toString()) {
            ind = index
          }
        })
        solutionList.splice(ind, 1)
        setStorage('solutionList', solutionList)
        this.$message({
          message: '取消收藏成功！',
          type: 'success'
        })
        this.getCollectionStatus()
      }
    },
    // 日期格式化
    format () {
      function addZero (data) {
        data = data.toString()
        if (data.length < 2) {
          return '0' + data
        } else {
          return data
        }
      }
      let time = new Date()
      let year = addZero(time.getFullYear())
      let month = addZero(time.getMonth())
      let day = addZero(time.getDay())
      let hours = addZero(time.getHours())
      let minutes = addZero(time.getMinutes())
      let second = addZero(time.getSeconds())
      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + second
    },
    // 获取方案数据
    getDetail () {
      this.$request.get(`/product/businesssolution/info/${this.$route.query.id}`)
        .then(data => {
          this.thumbnailUrl = (data && data.thumbnailUrl) || ''
          this.imgList = (data && data.sysOssEntities) || []
        })
        .catch(() => { })
    },
    // 查询方案是否收藏
    getCollectionStatus () {
      if (getAccessToken()) {
        this.$request.get(`/plan/collectionplan/findCollectionPlanBySolutionId`, { params: { solutionId: this.$route.query.id } })
          .then(data => {
            if (data.code > -1) {
              this.collectionStatus = true
            } else {
              this.collectionStatus = false
            }
          })
          .catch(() => { })
      } else {
        let solutionList = getStorage('solutionList')
        if (solutionList && solutionList.length > 0) {
          for (let i = 0; i < solutionList.length; i++) {
            if (solutionList[i].solutionId.toString() === this.$route.query.id.toString()) {
              this.collectionStatus = true
              break
            } else {
              this.collectionStatus = false
            }
          }
        } else {
          this.collectionStatus = false
        }
      }
    },
    moveOut () {
      this.timer = setTimeout(_ => {
        this.listShow = false
      }, 1000)
    },
    moveOver () {
      clearInterval(this.timer)
    },
    // 跳转一级目录
    changeMenu (name) {
      this.$router.push({ name: 'planList', query: { title: name } })
    }
  },
  created () {
    this.getDetail()
    this.getCollectionStatus()
    // 获取解决方案数据
    this.$request.get(`/product/businesssolution/findSolutionTree`)
      .then(data => {
        // console.log(data.data)
        this.solutionMenuList = data.data
      })
  }
}
</script>

<style scoped>
.banner {
  background: url("/static/img/bannerplan.jpg") no-repeat top center;
}

.content {
  font-size: 14px;
  line-height: 35px;
}

.topMargin {
  margin-top: 30px;
  min-height: 500px;
  margin-bottom: 30px;
}

.divimg {
  width: 100%;
  height: auto;
  padding: 5px;
}
.divimg img {
  width: 50%;
  border: 0px;
  /* float: left; */
}
@media (min-width: 720px) {
  .divimg {
    padding: 5px;
  }
  .divimg img {
    width: 100%;
    /*border: 3px;*/
    /* float: left; */
  }
}
.font_link_fw a {
  color: #666;
}
.font_link_fw a:hover {
  color: #666;
}
.inquiryButton {
  position: fixed;
  z-index: 11;
  right: 0px;
  top: 260px;
  cursor: pointer;
}
.menu_list {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 150px;
  /*height: 212px;*/
  z-index: 10;
  background-color: #f0f0f0;
  font-size: 14px;
  /*overflow: hidden;*/
  border-bottom: 2px #679dcc solid;
}
.menu_list:hover {
  cursor: pointer;
}
.productHref {
  cursor: pointer;
  color: #409eff;
}
</style>
